import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

export default function infoLinkTableData({ peopleList = [],  onEditClick }) {
  return {
    columns: [
      { Header: "Country", accessor: "country", width: "25%", align: "left" },
      { Header: "Video Count", accessor: "count", width: "20%", align: "center" },
      { Header: "Info Link", accessor: "link", width: "30%", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],

    rows: peopleList.map((person) => ({
      country: (
        <MDBox display="flex" alignItems="center" gap={1}>
          <MDTypography variant="button" style={{ fontSize: 32 }}>
            {person?.emoji}
          </MDTypography>
          <MDTypography variant="button" fontWeight="medium">
            {person?.name}
          </MDTypography>
        </MDBox>
      ),
      count: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {person?.videoCount}
        </MDTypography>
      ),
      link: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {person?.infoLink}
        </MDTypography>
      ),
      actions: (
        <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
          <IconButton size="small" onClick={() => onEditClick(person)}>
            <EditIcon fontSize="small" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
